import styled from 'styled-components';
import { ButtonCss } from './Button';

export const AButton = styled.a`
  ${ButtonCss}

  padding-top:0;
  padding-bottom:0;
  height:34px;
  text-align: center;
  text-decoration:none;
`;
